import type { OmnibusPriceFF } from '../../context/PricesProvider'

export const getHideSaleOrPromoPrice = (
	featureFlagInfo: OmnibusPriceFF,
	countryISO: string,
	showOmnibusPrice: boolean
) => {
	const { enabled, variables } = featureFlagInfo

	const countries = variables?.first_level_price_countries?.countries ?? []

	return (
		enabled && showOmnibusPrice && !countries.includes(countryISO.toLowerCase())
	)
}
